angular.module("Main").directive("systeamLanguageSelect", languageSelect);

function languageSelect() {
    return {
        templateUrl: "./app/Main/controls/languageSelect/languageSelect.html",
        restrict: "EA",
        replace: true,
        scope: {},
        controller: LanguageSelectController,
        controllerAs: "vm",
        bindToController: true
    };
}

LanguageSelectController.$inject = ["$rootScope", "$translate", "tmhDynamicLocale", "$localStorage", "LANGUAGES", "BookingService"];

function LanguageSelectController($rootScope, $translate, tmhDynamicLocale, $localStorage, LANGUAGES, BookingService) {
    var vm = this;
    loadLayoutConfiguration();

    vm.languageList = LANGUAGES;


    if (screen.width < 600) {
        vm.isMobilePhone = true;
    } else {
        vm.isMobilePhone = false;
    }

    if (_.isNil(vm.currentLanguage)) {
        vm.currentLanguage = getLocalStorageLanguage();
        tmhDynamicLocale.set(vm.currentLanguage.lang);
        $translate.use(vm.currentLanguage.lang);
    }

    vm.changeLanguage = function (lang) {
        var oldLang = $translate.use();
        if (lang.lang !== oldLang) {
            $translate.use(lang.lang).then(function () {
                vm.currentLanguage = lang;
                $localStorage.currentLanguage = lang;
                tmhDynamicLocale.set(lang.lang);
            });
        }
    };
    function loadLayoutConfiguration() {
        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.layoutSettings = angular.fromJson(data.Layout);
        })
    }

    function getLocalStorageLanguage() {
        if (_.isNil($localStorage.currentLanguage))
            $localStorage.currentLanguage = _.first(LANGUAGES);

        return $localStorage.currentLanguage;
    }
}